import axios from 'axios';
import Qs from 'qs';

const baseURL =
	window.location.protocol === 'https:'
		? 'https://api.admiterepolitie.ro'
		: 'http://localhost:8080';

const instance = axios.create({
	baseURL: baseURL,
	paramsSerializer(params) {
		return Qs.stringify(params, { arrayFormat: 'repeat' });
	}
});

// Request interceptor for API calls
instance.interceptors.request.use(
	async (config) => {
		const storage = localStorage.getItem('userData');
		if (storage) {
			config.headers = {
				Authorization: `Bearer ${JSON.parse(storage).access}`,
				Accept: 'application/json',
				'Content-Type': 'application/json'
			};
		}

		return config;
	},
	(error) => {
		Promise.reject(error);
	}
);

// Response interceptor for API calls
instance.interceptors.response.use(
	(response) => {
		return response;
	},
	async (error) => {
		if (error.code === 'ERR_CANCELED') {
			return;
		}

		const storage = localStorage.getItem('userData');
		let userData;

		if (storage) {
			userData = JSON.parse(storage);
		}

		const originalRequest = error?.config;
		if (
			error.response.status === 401 &&
			userData?.refresh &&
			!originalRequest._retry &&
			originalRequest.url !== '/api/login'
		) {
			originalRequest._retry = true;

			try {
				const res = await axios({
					method: 'get',
					url: baseURL + '/api/refreshToken',
					headers: { Authorization: 'Bearer ' + userData.refresh }
				});

				userData.access = res?.data?.message?.Token.access_token;
				userData.refresh = res?.data?.message?.Token.refresh_token;

				localStorage.setItem('userData', JSON.stringify(userData));
			} catch (err) {
				if (err.response.status === 404) {
					originalRequest._retry = true;
					localStorage.clear();
					window.location.reload();
				}
			}

			return instance.request(originalRequest);
		}

		if (error.response.status === 403) {
			navigator.serviceWorker.controller?.postMessage({ type: 'CLEAR_CACHE' });
			localStorage.clear();
			window.location.href = '/';
		}
		return Promise.reject(error);
	}
);

export default instance;
